import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tool",
  "use": "icon-tool-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tool\">\n  <path d=\"M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z\" fill=\"#409EFF\" />\n  <path d=\"M464 336c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-48z\" fill=\"#409EFF\" />\n  <path d=\"M512 688c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176zm0-288c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112z\" fill=\"#409EFF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/tool.svg
// module id = Y44e
// module chunks = 100